import * as z from "zod/v4";

/**
 * Resolves a scanned inner-parcel barcode to the fulfillment group + the
 * specific parcel tracker, so it can be added to an open overbox.
 */
export const resolveOverboxScan = {
  name: "resolveOverboxScan" as const,
  input: z.object({ trackingCode: z.string() }),
  output: z.discriminatedUnion("found", [
    z.object({
      found: z.literal(true),
      fulfillmentGroupId: z.string(),
      trackerId: z.string(),
      trackingCode: z.string(),
      orderName: z.string().nullable(),
    }),
    z.object({
      found: z.literal(false),
      reason: z.enum(["not_found", "no_tracker"]),
    }),
  ]),
};
